import { useAuthorization } from 'framework/authorization';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import { useShowContext } from 'framework/show';
import type { Data } from 'framework/types';

const ModalAccessButton = ({
  permission,
  isVisible = () => true,
  onClick,
  IconComponent,
  isTeamTab = false,
}: {
  permission: string;
  isVisible?: (data: Data) => boolean;
  onClick: (data: Data) => void;
  IconComponent: React.ComponentType<any>;
  isTeamTab?: boolean;
}) => {
  const { data } = useShowContext();
  const { isGranted } = useAuthorization();

  if (isGranted(permission) && isVisible(data)) {
    return (
      <IconButton
        onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          e.stopPropagation();
          onClick(data);
        }}
        sx={{ '&.MuiIconButton-root': { p: 0, mr: isTeamTab ? 1 : 0 } }}
      >
        <IconComponent color="primary" />
      </IconButton>
    );
  } else {
    return null;
  }
};

export default ModalAccessButton;
